// Set up rails-ujs
import Rails from '@rails/ujs'
Rails.start()

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Notifications from 'vue-notification'
import { routes } from 'main-page/routes/index'
import interceptorsSetup from 'interceptors'
import errorsHandler from 'handlers/errors'

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Notifications)

interceptorsSetup()
errorsHandler()

Vue.prototype.$enterCode = 13

document.addEventListener('DOMContentLoaded', () => {
  const router = new VueRouter({
    routes: routes
  })
  const app = new Vue({
    router,
      }
  ).$mount('#app-main-page')
})
